import AxiosClient from "../AxiosClient";

export const getProductClassL = (params) => {
  const url = "/api/productClassL/searchInfoList";
  return AxiosClient.post(url, params);
};
